const DB_NAME = "POS_DB";
const DB_VERSION = 2;

export const IDB_STORES = {
    CARTS: "carts",
    INVOICES: "invoices",
    CUSTOMERS: "customers",
    PRODUCTS: "products",
    SERVICES: "services",
    STORES: "stores",
    EMPLOYEES: "employees",
    POS_DRAFT: "posDraft",
};

let db;

/* ---------------- INIT ---------------- */

function initDB() {
    return new Promise((resolve, reject) => {
        if (db) return resolve(db);

        const request = indexedDB.open(DB_NAME, DB_VERSION);

        request.onupgradeneeded = (e) => {
            const database = e.target.result;

            Object.values(IDB_STORES).forEach((store) => {
                if (!database.objectStoreNames.contains(store)) {
                    database.createObjectStore(store, { keyPath: "_id" });
                }
            });
        };

        request.onsuccess = () => {
            db = request.result;
            resolve(db);
        };

        request.onerror = () => reject(request.error);
    });
}

/* ---------------- HELPERS ---------------- */

function getStore(storeName, mode = "readonly") {
    const tx = db.transaction(storeName, mode);
    return tx.objectStore(storeName);
}

function resolveStore(ref) {
    if (ref.includes("cart")) return IDB_STORES.CARTS;
    if (ref.includes("invoice")) return IDB_STORES.INVOICES;
    if (ref.includes("customer")) return IDB_STORES.CUSTOMERS;
    if (ref.includes("product")) return IDB_STORES.PRODUCTS;
    if (ref.includes("service")) return IDB_STORES.SERVICES;
    if (ref.includes("store")) return IDB_STORES.STORES;
    if (ref.includes("employee")) return IDB_STORES.EMPLOYEES;
    if (ref.includes("posDraft")) return IDB_STORES.POS_DRAFT;
    return null;
}

/* ---------------- CRUD ---------------- */

export async function idbGetData(ref, id = null) {
    await initDB();
    const store = resolveStore(ref);

    return new Promise((resolve) => {
        const req = id
            ? getStore(store).get(id)
            : getStore(store).getAll();

        req.onsuccess = () => resolve({ data: req.result || [] });
    });
}

export async function idbPostData(ref, payload) {
    await initDB();
    const store = resolveStore(ref);

    payload._id ||= crypto.randomUUID();

    return new Promise((resolve) => {
        getStore(store, "readwrite").put(payload);
        resolve({ success: true, data: payload });
    });
}

export async function idbPutData(ref, payload) {
    return idbPostData(ref, payload);
}

export async function idbDeleteData(ref) {
    await initDB();
    const store = resolveStore(ref);
    const id = ref.split("/").pop();

    return new Promise((resolve) => {
        getStore(store, "readwrite").delete(id);
        resolve({ success: true });
    });
}
